/**
 * 基类Cell形状
 * @enum
 */
export const ShapeEnum = {
    /**@type {String} 矩形 */
    RECT: 'rect',
    /**@type {String} 圆形 */
    CIRCLE: 'circle',
    /**@type {String} 椭圆 */
    ELLIPSE: 'ellipse',
    /**@type {String} 多边形 */
    POLYGON: 'polygon',
    /**@type {String} 菱形 x6不存在此类型 */
    DIAMOND: 'diamond'
}

/**
 * Node类型
 * @enum
 */
export const NodeTypeEnum = {
    /**@type {String} 开始节点 */
    BEGIN: 'begin-node',
    /**@type {String} 条件节点 */
    CONDITION: 'condition-node',
    /**@type {String} 尾部节点 */
    TAIL: 'tail-node',
    /**@type {String} 数据采集任务节点 */
    DATA_COLLECT: 'data-collect-node',
    /**@type {String} 数据加工任务节点 */
    DATA_JOB: 'data-job-node',
}

/**
 * 工具类型
 * @enum
 */
export const ToolTypeEnum = {
    /**@type {String} 删除元素 */
    REMOVE_BUTTON: 'custom-remove-button'
}

/**
 * 事件分发类型
 * @enum
 */
export const CustomEventTypeEnum = {
     /**@type {String} 画布空白区域点击触发 */
    BLANK_CLICK: '__antv_x6_custom_event_type_blank_click__',
    /**@type {String} 单元点击触发 */
    CELL_CLICK: '__antv_x6_custom_event_type_cell_click__',
    /**@type {String} 节点点击触发 */
    NODE_CLICK: '__antv_x6_custom_event_type_node_click__',
    /**@type {String} 双击节点触发 */
    DOUBLE_NODE_CLICK: '__antv_x6_custom_event_type_cell_double_click__',
    /**@type {String} 删除节点触发 */
    NODE_REMOVE: '__antv_x6_custom_event_type_node_remove__',
    /**@type {String} 帮助信息 */
    HELP: '__antv_x6_custom_event_type_help__',
    /**@type {String} tooltips 回调 */
    TOOLTIPS_CALLBACK: '__antv_x6_custom_event_type_tooltips_callback__',
    /**@type {String} 冻结画布 */
    FREEZE_GRAPH: '__antv_x6_custom_event_type_freeze_graph__',
    /**@type {String} 运行时异常 */
    RUNTIME_ERR: '__antv_x6_custom_event_type_runtime_err__',
    /**@type {String} 节点与任务关联更改 */
    JOB_LINK: '__antv_x6_custom_event_type_job_link__',
    /**@type {String} 任务流程提交 */
    FLOW_SUBMIT: '__antv_x6_custom_event_type_flow_submit__',
}

/**
 * 选择状态
 * @enum
 */
export const SelectStateEnum = {
    /**@type {String} 已选中 */
    SELECTED: 'selected',
    /**@type {String} 未选中 */
    UN_SELECTED: 'unselected'
}

/**
 * 配置项
 * @enum
 */
export const Config = {
    /**@type {String} 可操作Node区 插槽 */
    PANEL_AREA_SLOT: 'panel_area_slot',
    /**@type {String} Tooltips 插槽 */
    TOOLTIPS_SLOT: 'tooltips_slot',
}

/**
 * 节点触发类型
 */
export const ActionType = {
    /**@type {String} 触发器 */
    TRIGGER: 'TRIGGER',
    /**@type {String} 条件 */
    CONDITION: 'CONDITION',
    /**@type {String} 动作 */
    ACTION: 'ACTION',
    /**@type {String} 数据采集 */
    DATA_COLLECT: 'DATA_COLLECT',
    /**@type {String} 数据加工 */
    DATA_JOB: 'DATA_JOB',
}

/**
 * 缓存
 * @enum
 */
export const StoreKey = {
    GRAPH: '__antv_x6_store_key_graph__'
}